/**
 * Manual address-fields reveal.
 *
 * Both the customer-address page and the Direct Debit page render a
 * `#toggle-address-fields-visibility` checkbox ("enter address manually") and a
 * `#address-manual` block. The block's `.initialHide`/`.showNew` classes carry
 * no CSS, so visibility is driven here via inline styles: hidden by default,
 * revealed when the box is ticked. The Loqate component reveals the block
 * directly (setting the checkbox + display) without firing `change`, so there
 * is no conflict on the address page.
 */
import $ from 'jquery';

export default function initManualAddressToggle(): void {
    const $manual = $('#address-manual');
    const $checkbox = $('#toggle-address-fields-visibility');

    if (!$manual.length || !$checkbox.length) {
        return; // not on a page with a manual-address block
    }

    // Initial state — the server pre-checks the box when manual fields are
    // required (e.g. validation errors), otherwise start hidden.
    if ($checkbox.is(':checked')) {
        $manual.show();
    } else {
        $manual.hide();
    }

    $checkbox.on('change', function () {
        if ($(this).is(':checked')) {
            $manual.slideDown();
        } else {
            $manual.slideUp();
        }
    });
}
